import axios from 'axios';
import router from "@js/router";
import { useAuthStore } from "@stores";

export default function () {
    const authStore = useAuthStore();

    const onRequest = (request) => {
        request.headers = request.headers || {};
        request.headers.Accept = 'application/json';

        const accessToken = localStorage.getItem('access-token');
        if (accessToken) {
            request.headers.Authorization = `Bearer ${accessToken}`;
        }

        return request;
    };

    const onResponseError = async (error) => {
        const status = error.response?.status;
        const cfg = error.config;

        // anti-loop: ak padne refresh endpoint, neskúšaj refreshovať znova
        if (status === 401 && cfg?.url?.includes('auth/refresh-token')) {
            localStorage.removeItem('access-token');
            await router.push({ name: 'Login' });
            return new Promise(() => {});
        }

        if (status === 401 && cfg && !cfg.isRetry) {
            cfg.isRetry = true;

            try {
                const { token } = await authStore.refreshToken();

                if (token) {
                    localStorage.setItem('access-token', token);
                    cfg.headers = cfg.headers || {};
                    cfg.headers.Authorization = `Bearer ${token}`;
                    cfg.headers.Accept = 'application/json';
                    return axios.request(cfg);
                }
            } catch (e) {
                // fallthrough
            }

            localStorage.removeItem('access-token');
            await router.push({ name: 'Login' });
            return new Promise(() => {});
        }

        return Promise.reject(error);
    };

    axios.defaults.baseURL = import.meta.env.VITE_AMOS_ENDPOINT;
    axios.interceptors.request.use(onRequest, (e) => Promise.reject(e));
    axios.interceptors.response.use((r) => r, onResponseError);
}
